<template lang="html">
  <div class="ui segment">
    <h3 class="ui header">
      <img v-if="category.image" :src="category.image" class="ui circular image" />
      <button
        v-if="!category.main"
        class="ui right floated mini basic button"
        type="button"
        @click="loadCategory(category.parentId)"
      >
        <i class="reply icon"></i>
        Volver
      </button>
      <div class="content">
        {{ category.label }}
        <div class="sub header">
          {{ category.description }}
        </div>
      </div>
    </h3>

    <div class="ui grid">
      <div
        class="doubling four column row"
        v-for="(row, index) in rows"
        :key="'row-' + index"
      >
        <div class="four wide column" v-for="(item, idx) in row" :key="'column-' + idx">
          <a
            class="ui card"
            :class="item.color"
            href="javascript:void(0)"
            @click="loadCategory(item.id, item.brandId)"
          >
            <div class="content flex" :class="{ 'justify-items': !item.image }">
              <img
                v-if="item.image"
                class="middle aligned mini ui image flex-img"
                :src="item.image"
              />
              <div class="header flex-item">
                {{ item.label }}
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ITEMS_PER_ROW = 4;

export default {
  name: "CategoryDetails",
  props: ["category"],
  computed: {
    rows: function () {
      const rows = [];
      let row = [];

      if (this.category && this.category.children) {
        this.category.children.forEach((item, i) => {
          if (row.length < ITEMS_PER_ROW) {
            row.push(item);
          } else {
            rows.push(row);
            row = [];
            row.push(item);
          }
        });

        if (row.length > 0) rows.push(row);

        return rows;
      } else if (this.category.isFinal) {
        this.category.brands.forEach((item, i) => {
          if (row.length < ITEMS_PER_ROW) {
            row.push({
              id: this.category.id,
              label: item.name,
              brandId: item._id,
            });
          } else {
            rows.push(row);
            row = [];
            row.push({
              id: this.category.id,
              label: item.name,
              brandId: item._id,
            });
          }
        });

        if (row.length > 0) rows.push(row);

        return rows;
      }

      return rows;
    },
  },
  methods: {
    loadCategory: function (categoryId, brandId) {
      const payload = {
        category: categoryId | null,
        brand: brandId,
      };
      this.$emit("onLoadCategory", payload);
    },
  },
};
</script>

<style lang="css" scoped>
.flex {
  display: flex;
  align-items: center;
  padding: 10px !important;
}
.flex-img {
  margin-right: 10px !important;
}
.flex-item {
  font-size: 13px !important;
}
.justify-items {
  justify-content: center;
}
</style>
